module.exports = __webpack_public_path__ + "static/media/spinnerCat.4dd64310.gif";